/**
 * 缓存说明:用户权限
 */
import vm from '@/cache/storeTools.js'
import roleApi from '@/components/api/roleApi.js'
import unitApi from '@/components/api/unitApi'
import userApi from  '@/components/api/userApi'
import menuApi from  '@/components/api/menuApi'
import deviceApi from '@/components/api/deviceApi'
var basestate = {
	roleList: [], //角色列表
	nowUserInfo: {
		//当前用户信息
	},
	rights: {},
	unitList: [],
	unitUserList:{
		//key : unit单位
		//value :单位下的userList
	},
	usersRights:{
		//key : userid
		//value :用户拥有的rightsList
	}
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getRightByUserId(state, getters ){
			return	userId =>{
				if (!state.usersRights[userId]) {
					store.commit("getRightByUserId",userId)
				}
				return state.usersRights[userId]
			}
		},
		getRoleList(state, getters) {
			if (isempty(state.roleList)) {
				store.commit("getRoleList")
			}
			return state.roleList
		},
		getRights(state, getters) {
			if (isempty(state.rights)) {
				store.commit("getRights")
			}
			return state.rights
		},
		//找出单位下的用户列表
		getUserListByUnitId(state, getters ){
			return	unitId =>{
				if (!state.unitUserList[unitId]) {
					store.commit("getUserListByUnitId",unitId)
				}
				return state.unitUserList[unitId] ?state.unitUserList[unitId] :[]
			}
		}
	},
	mutations: {
		cleanRole(state) {
			vm.Vue.set(state, 'roleList', [])
		},
		getRightByUserId(state,userId){
			menuApi.getRightByUserId(userId,res=>{
				vm.Vue.set(state.usersRights,userId, res)
			})
		},
		//获取全由的权限
		getRights(state) {
// 			menuApi.getAllRight(respon=>{
// 				state.rights = respon
// 				deviceApi.getControlDeviceTree(respon => {
// 					state.rights['controlDeviceTree'] = [respon]
// 				})
// 				deviceApi.getReadDeviceTree(respon => {
// 					state.rights['readDeviceTree'] = [respon]
// 				})
// 			})
		
			
		},
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		getRoleList(state) {
			roleApi.getAllRole(res => {
				vm.Vue.set(state, 'roleList', res)
			})
		},
		setRoleList(state, data) {
			//查询当前用户的信息
			vm.Vue.set(state, 'roleList', data)
		},
		setRight(state, data) {
			vm.Vue.set(state, 'rights', data)
		},
		getUserListByUnitId(state,unitId) {
			userApi.findUserByUnitId(unitId,res => {
				vm.Vue.set(state.unitUserList,unitId, res)
			})
			
		}
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
